import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Layout/team/team.js")